var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid",attrs:{"id":"app"}},[_c('div',{staticClass:"col-12"},[_c('h2',[_vm._v(_vm._s(_vm.title)+" Report Generator")]),_c('br')]),_c('Map')],1)}
var staticRenderFns = []

export { render, staticRenderFns }